import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCy40Fn0ZVJvTzh2chfDDn_vg7-5DDhBPs',
  authDomain: 'copenhagen-residences.firebaseapp.com',
  projectId: 'copenhagen-residences',
  storageBucket: 'copenhagen-residences.appspot.com',
  messagingSenderId: '1065684626994',
  appId: '1:1065684626994:web:2a09abf89e387c98d7162b',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
